export const SELLERS_INFO_DOMAIN_KEY = 'sellersInfo';

export enum SELLERS_INFO_DOMAIN {
  ALL_SELLERS = 'allSellers',
}
